import React from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux'
import { FormTemplateFields } from './index'
import { RadioGroup } from '../form/'
import { phoneRequired, required } from '../form/FormValidations'
import CopyToDestination from './CopyToDestination';
import { checkIsVisible } from '../HelperFunctions';
import PatientModeOfNotification from '../form/PatientModeOfNotification';
import FindingFieldRenderer from '../authorised/impressionFinding/exam/FindingFieldRenderer';

function FormTemplateField(props) {
  const { isTemplate, fieldValues, type, baseName, wrapperClasses, hideIsRequired, validate, isOpen, showCopy, isPhoneInput, showFindingField } = props
  let isVisible = fieldValues && fieldValues.visible && fieldValues.visible.toString() === "true"
  const fieldRenderType = (type === 'findingField' && !showFindingField) ? '' : type // if off setting > return to default
  const ownerSuiteFieldRenderType = (process.env.REACT_APP_SUITE_NAME == "OWNER-SUITE" && type === 'findingField')

  const setLabel = (isRequired) => {
    return <span>{fieldValues.custom_label} <span className="text-danger">{isRequired ? " *" : ''}</span></span>
  }

  const showCopyToDestination = () => {
    return <>{showCopy?.destination && <CopyToDestination showCopy={showCopy} source={props.name} />}</>
  }

  const renderTemplateFormField = () => {
    // Setting Component
    switch (type) {
      case "radioGroup":
        return (
          <RadioGroup
            {...props}
            name={`${baseName}[default_value]`}
            wrapperClasses={`label-icons ${wrapperClasses} ${!isVisible && 'opacity-5'}`}
            label={<FormTemplateFields isVisible={isVisible} baseName={baseName} isRequired={fieldValues.required} />}
          />
        )
      case 'mode_of_notification':
        return (
          <PatientModeOfNotification
            {...props}
            name={`${baseName}[default_value]`}
            wrapperClasses={`label-icons ${wrapperClasses} ${!isVisible && 'opacity-5'}`}
            label={<FormTemplateFields isVisible={isVisible} baseName={baseName} isRequired={fieldValues?.required} hideIsRequired={hideIsRequired} isModeOfNotificationDefaultVal={true} defaultValueReadOnly={true} defaultValueDisabled={true} />}
          />
        )
      default:
        return (
          <Field
            {...props}
            name={`${baseName}[default_value]`}
            wrapperClasses={`label-icons ${wrapperClasses} ${!isVisible && 'opacity-5'}`}
            label={<FormTemplateFields isVisible={isVisible} baseName={baseName} isRequired={fieldValues?.required} hideIsRequired={hideIsRequired} isFindingSupport={fieldRenderType || ownerSuiteFieldRenderType} />}
          />
        )
    }
  }

  const renderFormField = () => {
    let validateArr = validate || []
    const isRequired = fieldValues.required && checkIsVisible(fieldValues.required)

    switch (fieldRenderType) {
      case "radioGroup":
        return (
          <RadioGroup
            {...props}
            label={setLabel(isRequired)}
            validate={isOpen && isRequired ? [...validateArr, required] : validate}
          />
        )
      case 'mode_of_notification':
        return (
          <PatientModeOfNotification
            {...props}
            label={setLabel(isRequired)}
            validate={isOpen && isRequired ? [...validateArr, required] : validate}
          />
        )
      case 'findingField':
        // All Exam Form Fields Finding flow depends on props 'findingField'. Just pass the props
        return (
          <FindingFieldRenderer
            {...props}
            isRequired={isRequired}
            validate={validate}
            validateArr={validateArr}
            isPhoneInput={isPhoneInput}
          />
        )
      case "wysiwyg":
        return (
          <div className="col-12 px-7">
            <label>{fieldValues.custom_label}</label>
            <div dangerouslySetInnerHTML={{ __html: fieldValues.default_value }} />
          </div>
        )
      default:
        return (
          <Field
            {...props}
            label={<span>{setLabel(isRequired)} {showCopyToDestination()}</span>}
            validate={isOpen && isRequired ? isPhoneInput ? [...validateArr, phoneRequired] : [...validateArr, required] : validate}
            labelClasses={!fieldValues.custom_label && 'mb-0 d-inline'}
          />
        )
    }
  }

  return (
    isTemplate ? renderTemplateFormField() : isVisible && renderFormField()
  )
}

const mapStateToProps = (state) => {
  const { setting: { orgConfig } } = state
  return {
    showFindingField: orgConfig.org_config?.exam_settings?.auto_diagnosis
  }
}

export default connect(mapStateToProps)(FormTemplateField);